import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { getListSlideDesks, removeSlideDesk } from "@actions";
import { useHistory } from 'react-router-dom'
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import { Icon } from '@components/common'
import File from '@images/teachV2/file-upload.svg';
import { LoaderText } from "@utils";

//ui-partents
import { MessageEmtyData } from "@ui-partents/Message";
import { BtnIconDeleteV2, BtnIconEditV2 } from "@ui-partents/Button";
import { DateFormatter } from "@ui-partents/DateTime";
import { SearchCustomForTable } from "@ui-partents/Search";
import { WrapModalDeleteCommon } from "@ui-partents/Modal";

// Import the pagination configuration
import {paginationOptions} from "@utils";

const TeachPresentationLibrary = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const listCase = useSelector((state) => state?.getListSlideDesks || []);
  
  const handleEditButtonClick = (id) => {
    history.push({
      pathname: `/teach/presentation/${id}`,
      state: {  // location state
        listCase: true, 
      },
    })
  };

  useEffect(() => {
    dispatch(getListSlideDesks({
      action_type: "list_slide_decks"
    }));
  }, [dispatch])

  const columns = [
    {
      dataField: "title",
      text: "Title",
      headerClasses: "font-weight-500",
      formatter: (cell, row) => {
        return (
          <div className="d-flex align-items-center">
            <Icon src={File}/>
            <p className='ml-1'>{cell}</p>
          </div>
        );
      },
    },
    {
      dataField: "updated_at",
      text: "Date Created",
      headerClasses: "font-weight-500",
      formatter: (cell, row) => {
        return (
          <DateFormatter date={cell} format="MMMM Do YYYY, h:mm:ss A" />
        );
      },
    },
    {
      dataField: "",
      text: "Action",
      headerClasses: "font-weight-500 text-center",
      headerStyle: { width: "72px" },
      formatter: (cell, row) => {
        return (
          <div className="d-flex align-items-center justify-content-start">
            <BtnIconEditV2
              handleEditButtonClick={() => handleEditButtonClick(row.id)}
              colorIcon={`#16B364`}
            />
            <WrapModalDeleteCommon
              title={`Delete Presentation`}
              sub={`Are you sure you want to delete this presentation? This action cannot be undone.`}
              handleRemove={handleRemove}
              idRemove={row?.id}
            >
              {({onOpen}) => (
                <BtnIconDeleteV2 handleDelete={onOpen} />
              )}
            </WrapModalDeleteCommon>
          </div>
        );
      },
    }
  ];

  const handleRemove = (idDelete) => {
    const params = {
      action_type: "delete_slide_deck",
      id: idDelete,
    };
    dispatch(removeSlideDesk(params));
  };

  const contentTable = ({ paginationProps, paginationTableProps }) => (
    <React.Fragment>
      <ToolkitProvider
        keyField="id"
        data={listCase?.data || []}
        columns={columns}
        search
      >
        {(toolkitprops) => (
          <div>
            <div className="table-library__filter d-flex align-items-center justify-content-between">
              <p>Total Teaching Slides: {listCase?.data?.length}</p>
              <div className="boxSearch">
                <SearchCustomForTable
                  toolkitprops={toolkitprops}
                  paginationProps={paginationProps}
                  isResetPagination
                  searchMode="auto"
                  placeholder={`Search`}
                />
              </div>
            </div>
            {console.log(toolkitprops)}
            <BootstrapTable
              condensed
              wrapperClasses="table-custom-common table-responsive mt-4"
              bordered={false}
              data={(listCase?.data && listCase?.data) || []}
              columns={columns}
              noDataIndication={() => (
                <MessageEmtyData 
                  title="No Results Found"
                  text="Sorry, we couldn't find any matches for your search. Please try adjusting your search terms or using different keywords."
                />
              )}
              {...paginationTableProps}
              {...toolkitprops.baseProps}
            />
          </div>
        )}
      </ToolkitProvider>
      <div className="pagination-custom-case d-flex justify-content-end mr-4 mb-4">
        <PaginationListStandalone {...paginationProps} />
      </div>
    </React.Fragment>
  );

  const totalSize = listCase?.data?.length || 0; // Dynamically determine the total size

  // Generate pagination configuration dynamically
  const paginationConfig = paginationOptions({ totalSize });
  return (
    <div className="table-library position-relative">
      {listCase?.isLoading ? (
        <div className="height-loader mt-5">
          <LoaderText />
        </div>
      ) : (
        listCase?.data?.length === 0 ? (
          <MessageEmtyData
            title="Your Library is Empty"
            text="It looks like you haven't generated any teaching slides yet. Start creating a new one to see it here."
          />
        ) : (
          <PaginationProvider pagination={paginationFactory(paginationConfig)}>
            {contentTable}
          </PaginationProvider>
        )
      )}
    </div>
  )
}

export default TeachPresentationLibrary
